<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122 48" aria-labelledby="AnbiLogo" role="img">
    <title>Anbi Logo</title>
    <path fill="currentColor" d="M0 0h122v48H0z" />
    <path
      d="M110.9 9.7h-7.5v28.5h7.5V9.7zM88.2 32.4h-5.9v-6.1H88c1.5.1 2.9 1.1 2.9 3 0 2-1.4 3.1-2.7 3.1m-5.9-16.9h3.4c.7 0 1.3 0 1.9.1 1.4.2 2.3 1 2.3 2.6 0 1.7-1 2.4-2.3 2.6-.6.1-1.3.2-1.9.2h-3.4v-5.5zm11.2 7.3c2.8-1 4.2-3 4.2-5.6 0-3.7-2.7-6.7-7.4-7.3-1.5-.2-2.1-.2-3.7-.2H74.8v28.5h11.4c1.8 0 2.8 0 4.2-.2 3.9-.5 8.2-3.1 8.2-8.4.1-3.4-1.5-5.8-5.1-6.8M68.9 38.3V9.7h-7.5v12.2c0 1.7 0 4.6.2 7.5L50.8 9.7h-9.3v28.5H49V26.5c0-1.7 0-4.2-.2-7.1l10.4 18.9h9.7zm-45.4-22l2.7 8.8h-5.3l2.6-8.8zm4.4 14.6l2.4 7.4h8.1L28.2 9.7H19L8.7 38.3h7.9l2.4-7.4h8.9z"
      fill="#fff"
    />
  </svg>
</template>
